import { render, staticRenderFns } from "./card-producto.vue?vue&type=template&id=2da9c39b&scoped=true&"
import script from "./card-producto.vue?vue&type=script&lang=js&"
export * from "./card-producto.vue?vue&type=script&lang=js&"
import style0 from "./card-producto.vue?vue&type=style&index=0&id=2da9c39b&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da9c39b",
  null
  
)

export default component.exports